/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserResponse } from '../../models/user-response';
import { UserSearch } from '../../models/user-search';

export interface FindUsers$Params {
  
    /**
     * Search criteria.
     */
    body: UserSearch
}

export function findUsers(http: HttpClient, rootUrl: string, params: FindUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserResponse>>> {
  const rb = new RequestBuilder(rootUrl, findUsers.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserResponse>>;
    })
  );
}

findUsers.PATH = '/rest/user/search';
